import { render, staticRenderFns } from "./IndexShipment.vue?vue&type=template&id=7f2fafb1&scoped=true&"
import script from "./IndexShipment.vue?vue&type=script&lang=js&"
export * from "./IndexShipment.vue?vue&type=script&lang=js&"
import style0 from "./IndexShipment.vue?vue&type=style&index=0&id=7f2fafb1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2fafb1",
  null
  
)

export default component.exports